import { useTranslation } from 'react-i18next';

import { BillingUsageFeature } from 'services/repositories/billing/billing';
import { cn } from 'support/helpers/cn/cn';

type FeaturesBreakdownTableProps = {
  features: Array<BillingUsageFeature>;
};

export const FeaturesBreakdownTable = ({ features }: FeaturesBreakdownTableProps) => {
  const { t } = useTranslation();

  return (
    <div className="w-full overflow-hidden rounded-md border border-gray-200">
      <div className="grid grid-cols-[1fr_auto]">
        <div className="border-b border-gray-200 bg-white px-3 py-2 text-xs leading-4 text-gray-500">
          {t('settings:usageAndModules.featuresTable.name')}
        </div>
        <div className="border-b border-gray-200 bg-white px-3 py-2 text-right text-xs leading-4 text-gray-500">
          {t('settings:usageAndModules.featuresTable.usedCredits')}
        </div>
        {features.map((feature, index) => {
          const striped = index % 2 === 1;
          return (
            <div key={feature.feature_id} className="contents">
              <div
                className={cn(
                  'border-b border-gray-200 p-3 text-xs leading-4 text-gray-700',
                  striped ? 'bg-gray-50' : 'bg-white',
                )}
              >
                {feature.display_name}
              </div>
              <div
                className={cn(
                  'border-b border-gray-200 p-3 text-right text-xs leading-4 text-gray-700',
                  striped ? 'bg-gray-50' : 'bg-white',
                )}
              >
                {Math.round(feature.credits_used)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
